import React from "react";

const SupplierinvoicesEdit = () => {
	return <div>CRM, Not implemened yet</div>;
};
export default SupplierinvoicesEdit;
